import LogRocket from 'logrocket';

import { sanitize, sanitizeURL } from '@@/auto/utils/pii';

export function isEnabled() {
  return !!(
    process.env.REACT_APP_ENV !== 'development' &&
    process.env.REACT_APP_LOGROCKET_PROJECT_ID
  );
}

export function initIfEnabled() {
  if (!isEnabled()) {
    return;
  }

  LogRocket.init(process.env.REACT_APP_LOGROCKET_PROJECT_ID!, {
    release: window.__COMMIT_SHA__,
    // https://app.logrocket.com/umqday/toggle-auto/settings/privacy
    dom: {
      textSanitizer: false,
      inputSanitizer: true,
    },
    browser: {
      urlSanitizer: (url) => sanitizeURL(url),
    },
    network: {
      requestSanitizer: (req) => sanitize(req),
      responseSanitizer: (res) => sanitize(res),
    },
    shouldSendData: () => !('Cypress' in window),
  });
}
